<template>
	<div class="border-connectProBlue border-2 pl-8 pr-8 pb-8 pt-4 rounded min-h-72">
		<div v-if="process.customer.customer_main !== null">
			<div v-if="documentsInApp.length !== 0" class="space-x-16 font-bold w-full justify-start mb-2" style="text-align: start">
				{{ $t('shared_documents_input') }}
			</div>
			<div
				v-if="documentsInApp.length !== 0"
				class="grid grid-cols-3 gap-x-8 xl:gap-x-24 gap-y-4 mt-4 border-b-2 pb-5 mb-5"
				style="text-align: start"
			>
				<div v-for="document in documentsInApp" :key="document.uuid" class="font-medium">{{ document.label }}</div>
			</div>

			<BaseSelect
				class="w-1/2"
				v-if="documents"
				ref="documents"
				:label="documentsInApp.length !== 0 ? $t('other_documents_input') : $t('documents')"
				:options="documents"
				v-model="selectedDocuments"
				track-by="uuid"
				options-label="label"
				:required="false"
				:multiple="true"
			/>
			<div class="flex justify-end">
				<BaseButton class="btn-blue" @click="makeAvailableInApp">{{ $t('share') }}</BaseButton>
			</div>
		</div>
		<div class="flex space-x-16" v-else>
			<div class="text-black font-bold">
				{{ $t('customer_app_not_installed') }}
			</div>
		</div>
	</div>
</template>

<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import { PdfApiFactory } from '@/api/generated';
import defaultConfiguration from '@/api/defaultConfiguration';
import DocumentFileUploader from '@/components/forms/inputs/DocumentFileUploader.vue';

export default {
	name: 'ProcessDocumentUnblockDocumentsInAppTab',
	components: { BaseButton, BaseSelect },
	data() {
		return {
			documents: [],
			selectedDocuments: null,
			documentsInApp: [],
		};
	},
	props: {
		process: null,
		isActive: { default: false },
	},
	methods: {
		makeAvailableInApp() {
			if (this.selectedDocuments) {
				this.$swal({
					title: this.$t('sure').toString(),
					text: this.$t('share_in_app').toString(),
					icon: 'warning',
					cancelButtonText: this.$t('general.no').toString(),
					showCancelButton: true,
					confirmButtonText: this.$t('general.yes').toString(),
				}).then(result => {
					if (result.value) {
						const uuids = this.selectedDocuments.map(element => element.uuid);
						PdfApiFactory(defaultConfiguration.config(), defaultConfiguration.basePath, defaultConfiguration.axios)
							.pdfPublishinappPost({ uuids })
							.then(response => {
								this.$swal(this.$t('general.success').toString(), this.$t('shared_in_app_successfully').toString(), 'success');
								this.$store.dispatch('updateDocuments', { id: this.$route.params.processId }).then(_ => {
									this.getDocuments();
								});
							})
							.catch(error => {
								this.$swal(this.$t('general.error').toString(), this.$t('shared_in_app_error').toString(), 'error');
							});
					}
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('choose_least_one_document').toString());
			}
		},
		getDocuments() {
			const tempDocuments = [];
			this.selectedDocuments = null;
			this.documents = [];
			this.documentsInApp = [];
			this.$store.getters.getDocumentsRepairShop.forEach(element => {
				tempDocuments.push(element);
			});
			this.$store.getters.getDocumentsDamageAssessor.forEach(element => {
				tempDocuments.push(element);
			});
			this.$store.getters.getDocumentsMisc.forEach(element => {
				tempDocuments.push(element);
			});

			tempDocuments.map(option => {
				if (option.uuid !== null && !option.show_in_app) {
					option.value = option.uuid;
					option.display = option.label;
					this.documents.push(option);
				}

				if (option.show_in_app) {
					this.documentsInApp.push(option);
				}
			});
			this.$store.commit('setUploadNew', false);
		},
	},
	watch: {
		'$store.getters.getUploadedNew': function() {
			if (this.$store.getters.getUploadedNew) {
				this.getDocuments();
			}
		},
		isActive: function(newValue) {
			if (newValue) {
				this.getDocuments();
			}
		},
	},
};
</script>

<style scoped></style>
